module.exports = __webpack_public_path__ + "static/accuracy-MRI-015425cc364d8c9d3613d347e31abe60.png";